class EnvService {
  constructor() {
    this.localDevEnv =
      process.env.VUE_APP_ENV === undefined ? "local" : process.env.VUE_APP_ENV;
    this.build = "NOTSET";
    this.environments = [
      {
        env: "local",
        apiHost: "http://localhost:5050",
        webbApp: "http://localhost:8080",
        cookieName: "ashore.app.local",
        stripeKey: "pk_test_D6ZhAI2nNZZegVcFOH5fYbej",
        loomKey: "9e5caf47-ed50-4d06-b7bc-443d44764d51",
        sentryDSN: "",
        directUploads: true,
        v2Downloads: true,
      },
      {
        env: "development",
        apiHost: "https://dev-api.ashoreapp.com",
        webbApp: "https://dev.ashoreapp.com",
        cookieName: "ashore.app.dev",
        stripeKey: "pk_test_D6ZhAI2nNZZegVcFOH5fYbej",
        loomKey: "9e5caf47-ed50-4d06-b7bc-443d44764d51",
        sentryDSN: "https://7224e372eb07a7b8a5688765cb3f4e4f@o4507221644607488.ingest.us.sentry.io/4507221653454848",
        directUploads: false,
        v2Downloads: false,
      },
      {
        env: "staging",
        // apiHost: "https://staging-api.ashoreapp.com",
        apiHost: "https://staging-api.ashoreapp.com",
        webbApp: "https://staging-sea.ashoreapp.com",
        cookieName: "ashore.app.staging",
        stripeKey: "pk_test_D6ZhAI2nNZZegVcFOH5fYbej",
        loomKey: "9e5caf47-ed50-4d06-b7bc-443d44764d51",
        sentryDSN: "https://7224e372eb07a7b8a5688765cb3f4e4f@o4507221644607488.ingest.us.sentry.io/4507221653454848",
        directUploads: true,
        v2Downloads: true,
      },
      {
        env: "production",
        apiHost: "https://api.ashoreapp.com",
        webbApp: "https://sea.ashoreapp.com",
        cookieName: "ashore.app.prod",
        stripeKey: "pk_live_a9Lt54FlBVLZ6160kGdj793B",
        loomKey: "9e5caf47-ed50-4d06-b7bc-443d44764d51",
        sentryDSN: "https://7224e372eb07a7b8a5688765cb3f4e4f@o4507221644607488.ingest.us.sentry.io/4507221653454848",
        directUploads: false,
        v2Downloads: false,
      },
    ];

    let curEnv =
      "staging".indexOf("_") > 0 ? this.localDevEnv : "staging";
    this.isLocalDev = "staging".indexOf("_") > 0;
    this.env = this.environments.filter((e) => e.env === curEnv)[0];
    this.envName = this.env.env;
    this.apiHost = this.env.apiHost;
    this.webbApp = this.env.webbApp;
    this.cookieName = this.env.cookieName;
    this.stripeKey = this.env.stripeKey;
    this.loomKey = this.env.loomKey;
    this.sentryDSN = this.env.sentryDSN;
    // Browser uploads straight to S3 via the v2 presign API (see DirectUploadService).
    this.directUploads = this.env.directUploads === true;
    // Single-file downloads via a temporary presigned link (v2 API route) instead of streaming through the API.
    this.v2Downloads = this.env.v2Downloads === true;
  }
}

EnvService.instance = new EnvService();
export default EnvService;
